import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment';
import { changeMonth, ADD, SUBTRACT } from '../../store/actions/dashboard/calendarActions';
import { fetchTotalHoursInMonth, 
  fetchTimesheets,
  resetTimesheet,
  HAS_REQUIRED_HOURS, 
  OVER_REQUIRED_HOURS, 
  BELOW_REQUIRED_HOURS, 
  WORK_HOURS } from '../../store/actions/timesheet/timesheetActions';
import { fetchHolidays } from '../../store/actions/holidays/holidaysActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import '../../css/calendar.css';
import '../../css/timesheets.css';

class TimesheetCalendar extends Component {

  componentDidMount() {
    this.props.fetchHolidays();
    this.props.fetchTimesheets();
  }

  generateWeekDays = () => {
    const weekDays = moment.weekdaysShort();
    let weekDaysRow = weekDays.length > 0 && weekDays.map((weekDay, key) => {
      return (
        <td key={key} className="align-center">{weekDay}</td>
      )
    })

    return (
      <tr>
        {weekDaysRow}
      </tr>
    )
  }

  firstDayOfMonth = () => {
    let dateObject = this.props.calendar.dateObject;
    let firstDay = moment(dateObject)
                 .startOf("month")
                 .format("d"); 
   return firstDay;
  }

  month = () => {
    return this.props.calendar.dateObject.format("MMMM");
  }

  monthNum = () => {
    const monthNum = this.props.calendar.dateObject.format("M"); 
    return ("0" + monthNum).slice(-2);
  }

  year = () => {    
    return this.props.calendar.dateObject.format("Y");
  }

  render() {
    const monthlyEntries = this.props.timesheets.monthlyEntries;
    const holidays = this.props.holidays.holidays;

    const monthYear = this.year() + "-" + this.monthNum();
    this.props.fetchTotalHoursInMonth(monthYear);

    const timesheets = this.props.timesheets.timesheets || [];

    let dateObject = this.props.calendar.dateObject;
    let blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(
        <td key={monthYear+i}>
          {""}
        </td>
      );
    }

    let daysInMonth = [];
    for (let d = 1; d <= dateObject.daysInMonth(); d++) {
      let hours = '';
      let day = ("0" + d).slice(-2);
      let date = this.year() + "-" + this.monthNum() + "-" + day;

      if (monthlyEntries && monthlyEntries.length > 0) {
        monthlyEntries.forEach(monthlyEntry => {
          if (monthlyEntry.time_entry_date === date && hours === '') {
            hours = +monthlyEntry.total_hours.toFixed(0);
          }
        })
      }
     
      let hoursStyle = HAS_REQUIRED_HOURS;
      const calendarMoment = moment(date); 
      const isWeekend = (calendarMoment.day() === 0 || calendarMoment.day() === 6);

      if (isWeekend) {
        hoursStyle = (+hours > 0) ? OVER_REQUIRED_HOURS : HAS_REQUIRED_HOURS;
        if (!hours) {
          hours = '';
        }
      } else {
        if (+hours > WORK_HOURS) {
          hoursStyle = OVER_REQUIRED_HOURS;
        } else if (+hours < WORK_HOURS) {
          hoursStyle = BELOW_REQUIRED_HOURS;
        }
      }

      let dateStyle = {}
      let holidaySpan = '';
      
      if (holidays) {
        holidays.forEach(data=> {
          if (data.date === date) {
            dateStyle = 'holiday-color-text';
            holidaySpan = (
              <OverlayTrigger
                key="tooltip-date"
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    {data.name || data.date}
                  </Tooltip>
                }
              >
                <div className={'font-weight-bold ' + dateStyle}>HOL</div>
              </OverlayTrigger>
            );
          }
        });
      }

      let linkComponent = hours;
      const currentTimesheet = timesheets.filter(timesheet => 
        (moment(timesheet.start_date) <= calendarMoment 
          && moment(timesheet.end_date) >= calendarMoment));
      if (currentTimesheet && currentTimesheet.length) {
        linkComponent = <Link to="#" onClick={(e) => {
              e.preventDefault();
              this.props.resetTimesheet();
              const timesheetURL = '/timesheet/update?id='+currentTimesheet.pop().timesheet_id;
              this.props.history.push(timesheetURL);
            }}> 
            {hours}
          </Link>
      }

      daysInMonth.push(
        <td key={d} className="align-center">
          <div className="calendar-cell">
            <div className={"font-weight-bold text-muted " + dateStyle}>
              {d}
            </div>
            <h4 id="timesheet-calendar-hours" className={hoursStyle}>
              {linkComponent}
            </h4>    
            {holidaySpan}    
          </div>
        </td>
      );
    }
    
    var totalSlots = [...blanks, ...daysInMonth];
    let rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row); // if index not equal 7 that means not go to next week
      } else {
        rows.push(cells); // when reach next week we contain all td in last week to rows 
        cells = []; // empty container 
        cells.push(row); // in current loop we still push current row to new container
      }
      if (i === totalSlots.length - 1) { // when end loop we add remain date
        rows.push(cells);
      }
    });

    let daysinmonth = rows.map((d, j) => {
      return <tr key={monthYear + j}>{d}</tr>;
    });

    return (
      <Row id="timesheet-calendar">
        <Col>
          <Row className="align-center" id="calendar-nav">
            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
              <Button className="btn-icon" onClick={(e) => {
                this.props.changeMonth(SUBTRACT);
              }}>
                <FontAwesomeIcon icon={faChevronLeft} />
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
              <h5>{ this.month() } { this.year() }</h5>
            </Col>
            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
              <Button className="btn-icon" onClick={(e) => {  
                this.props.changeMonth(ADD);
              }}>
                <FontAwesomeIcon icon={faChevronRight} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table>
                <tbody>
                  { this.generateWeekDays() }
                  {daysinmonth}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}


const mapStateToProps = (state) => ({
  calendar: state.calendar,
  timesheets: state.timesheets, 
  holidays: state.holidays 
})

const mapDispatchToProps = (dispatch) => {
  return {
    changeMonth: (...args) => dispatch(changeMonth(...args)),
    fetchTotalHoursInMonth: (...args) => dispatch(fetchTotalHoursInMonth(...args)),
    fetchHolidays: () => dispatch(fetchHolidays()),
    fetchTimesheets: () => dispatch(fetchTimesheets()),
    resetTimesheet: () => dispatch(resetTimesheet())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimesheetCalendar))